import styled, { css } from 'styled-components';

import {
    Spacer, Text, token, mediaMixin,
} from '@zillow/constellation';

export const StyledControlsSpacer = styled(Spacer)`
    border-top: 1px solid ${token('colors.gray300')};
`;

export const StyledSwitchContainerDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    ${mediaMixin('md', css`
        justify-content: flex-end;
    `)};
`;

export const StyledText = styled(Text)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const StyledEmphasizeText = styled(StyledText)`
    && {
        font-weight: 600;
    }
`;

export const StyledUnitCardDiv = styled.div`
    border: 1px solid ${token('colors.gray300')};
    border-bottom: 3px solid ${token('colors.blue400')};
    border-radius: 4px;
    background-color: ${token('colors.white')};
`;
